import { render } from "./FooterDefault.vue?vue&type=template&id=4ee89984&scoped=true"
import script from "./FooterDefault.vue?vue&type=script&lang=js"
export * from "./FooterDefault.vue?vue&type=script&lang=js"

import "./FooterDefault.vue?vue&type=style&index=0&id=4ee89984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee89984"]])

export default __exports__